import { httpGet, httpPost } from '@pressreader/services';
import { ReCaptchaVersion } from '@pressreader/utils';

import { NewUser, RegistrationStatus, SendVerificationEmailResult, SignInResultDto } from './types';

function apiSignIn(params: {
    userName: string;
    password: string;
    reCaptchaVersion: ReCaptchaVersion;
    reCaptchaToken: string;
    authProcessState?: string;
}): Promise<SignInResultDto> {
    return httpPost('auth', 'Signin', params, { disableRetry: true });
}

function apiSignInByKey(key: string): Promise<SignInResultDto> {
    return httpPost('auth', 'SigninByKey', { key });
}

function apiSignOut(): Promise<void> {
    return httpGet('auth', 'SignOut');
}

function apiRegister(data: NewUser): Promise<SignInResultDto> {
    return httpPost('auth', 'Register', JSON.stringify({ ...data, returnUrl: data.returnUrl ?? getReturnUrl() }), {
        contentType: 'application/json',
        disableRetry: true,
    });
}

function getReturnUrl() {
    const currentUrl = document.location.href;
    const url = new URL(currentUrl);
    const returnUrl = url.searchParams.get('returnUrl');
    return returnUrl || currentUrl;
}

function apiSendVerificationEmail(email: string): Promise<SendVerificationEmailResult> {
    return httpPost('EmailVerification', 'ReSendVerificationEmail', JSON.stringify({ email }), {
        contentType: 'application/json',
        disableRetry: true,
    });
}

function apiCheckRegistrationStatus(email: string): Promise<RegistrationStatus> {
    return httpGet('auth', 'RegistrationStatus', { email });
}

function apiGetExternalRequestKey(): Promise<{ Key: string }> {
    return httpGet('ExternalAuth', 'GetRequestKey');
}

function apiRecoverPassword(logonName: string): Promise<void> {
    return httpPost('v1/account', 'recoverpassword', JSON.stringify({ logonName }), { contentType: 'application/json', disableRetry: true });
}

export {
    apiCheckRegistrationStatus,
    apiGetExternalRequestKey,
    apiRecoverPassword,
    apiRegister,
    apiSendVerificationEmail,
    apiSignIn,
    apiSignInByKey,
    apiSignOut,
};
